import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  useTemplateTargetGroupDataTable,
} from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { InlineEmployee } from 'modules/employees/components/InlineEmployee'

interface Props {
  templateId: number
}

export const TemplateTargetGroupDataTable = ({ templateId }: Props) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const source = useTemplateTargetGroupDataTable(
    [
      {
        identifier: 'target',
        title: i18n.t('performance_process.reviews.peer_management.peers_datatable.employee'),
        fixed: true,
        kind: ProjectionKind.Custom,
        template: '{{ access }}',
        colSpan: 2,
        render: ({ access }) => {
          if (!access?.employee)
            return (
              <Text.Normal>{i18n.t('performance_process.reviews.evaluations.unknown')}</Text.Normal>
            )
          return <InlineEmployee employee={access?.employee} />
        },
      },
    ],
    {
      variables: {
        customTemplateId: Number(templateId),
        searchValue: debouncedSearch || '',
      },
    }
  )

  return (
    <DataTable.Provider
      source={source}
      pagination={{
        kind: 'offset',
        itemsPerPage: 20,
      }}
    >
      <Box gap="s16">
        <DataTable.HeadBar
          disableDefaultActions
          search={{
            placeholder: i18n.t('performance_process.reviews.target_management_search'),
            value: search,
            onChange: onSearch,
          }}
        />
        <DataTable.Table />
      </Box>
    </DataTable.Provider>
  )
}
